module.exports = __webpack_public_path__ + "static/migros-820067b358d97fc8542c972824debdff.png";